import { useState } from 'react'

import useMediaQuery from '@material-ui/core/useMediaQuery'
import EditContextProvider from 'Components/Hooks/ContextEdit'
import SetState from 'Components/Hooks/SetState'
import MuiDatables from 'Components/UI/Atoms/Table'
import AutocompleteFilter from 'Components/UI/Atoms/Table/Autocomplete'
import DateFilter from 'Components/UI/Atoms/Table/DatePickerFilter'
import { SUCURSAL, SUCURSAL_ORIGEN } from 'Constants'
import moment from 'moment'
import { interfaces } from 'service/interfaces'

import Edit from './Edit'

const CajaTable = (props) => {
  const { render, setRender, dataBefore } = props
  const windowSize = useMediaQuery('(min-width:1000px)')
  const [loading, setLoading] = useState(false)

  const [values, setValues] = useState({
    rows: [],
    header: [],
  })

  const { state, setOpen, setClose } = SetState()

  async function apiCall(options, callback) {
    const queryString =
      typeof options === 'string'
        ? `${options}&origen=ECO`
        : `${new URLSearchParams(options).toString()}&origen=ECO`
    setValues({
      rows: [],
      header: [],
    })
    try {
      const result = await interfaces.salesCaja.cajaList(`${queryString}`)
      setValues({
        rows: result.data,
        header: result.header.header.count,
      })
      callback()
    } catch (error) {}
  }

  async function cajaInfo(id) {
    const empresaString = values.rows.find((item) => item.id === id).origen
    const empresaId = SUCURSAL_ORIGEN.find((sucursal) => sucursal.label === empresaString).id

    await interfaces.salesCaja.infoOneCaja(id, empresaId).then((res) => {
      setOpen({
        data: {
          cajas: res.data.cajasInfo.sort((a, b) => a.id - b.id),
          cajaInfo: res.data.cajasInfo[0],
          gastos: res.data.gastos,
          historial: res.data.history,
          recibos: res.data.receipt,
          gastoTotal: res.data.gastoTotal,
        },
      })
    })
  }

  const RowsTransit = () =>
    values.rows.map((file) => [
      file.fecha,
      file.origen,
      file.origen === 'ECO' ? file.punto_venta : file.sucursal,
      file.total_sistema ? `$${parseFloat(file.total_sistema)}` : '$',
      file.total_fisico ? `$${parseFloat(file.total_fisico)}` : '$',
      file.gastos ? `$${parseFloat(file.gastos)}` : '$',
      '',
      file.usuario,
    ])
  const currentOrigen = values.rows.length > 0 ? values.rows[0].origen : 'ECO'

  let columns = [
    {
      name: 'fecha',
      label: 'Fecha',
      options: {
        filter: true,
        sort: false,
        sortThirdClickReset: true,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            const dateValue = filterList[index][0]
              ? moment(filterList[index][0], 'DD-MM-YYYY').toDate()
              : null
            return (
              <DateFilter
                filterList={filterList}
                onChange={onChange}
                index={index}
                column={column}
                label="Fecha"
                selectedDate={dateValue}
                handleDateChange={(date) => {
                  if (date && !isNaN(date.getTime())) {
                    const finalDate = moment(date).format('DD-MM-YYYY')
                    onChange([finalDate], index, column)
                  } else {
                    onChange([], index, column)
                  }
                }}
              />
            )
          },
        },
      },
    },
    {
      name: 'origen',
      label: 'Origen',
      options: {
        filter: true,
        sort: false,
        sortThirdClickReset: true,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            if (Object.keys(values).length > 0) {
              return (
                <AutocompleteFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label="Origen"
                  filterName="label"
                  options={SUCURSAL_ORIGEN}
                  defaultOption={{ label: 'ECO', id: 1 }}
                  fullWidth={true}
                />
              )
            }
          },
        },
      },
    },
    {
      name: 'sucursal',
      label: currentOrigen === 'ECO' ? 'Punto de venta' : 'Sucursal',
      options: {
        filter: true,
        sort: false,
        sortThirdClickReset: true,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            const origenFiltrado =
              filterList[1] && filterList[1][0] ? filterList[1][0] : currentOrigen
            const esECO = origenFiltrado === 'ECO'
            const opcionesDinamicas = esECO
              ? dataBefore.data.punto_venta.map((pv) => ({
                  ...pv,
                  label: `${pv.nombre} `,
                }))
              : SUCURSAL
            if (Object.keys(values).length > 0) {
              return (
                <AutocompleteFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label={esECO ? 'Punto de venta' : 'Sucursal'}
                  filterName="label"
                  options={opcionesDinamicas}
                  // defaultOption={{ label: 'ECO Río Cuarto', id: 1 }}
                  fullWidth={true}
                />
              )
            }
          },
        },
      },
    },
    {
      name: 'total_sistema',
      label: 'Total sistema',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'total_fisico',
      label: 'Total físico',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'gastos',
      label: 'Gastos',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: '',
      label: '',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'usuario',
      label: 'Usuario',
      options: {
        display: false,
        filter: true,
        sort: false,
        sortThirdClickReset: true,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            if (Object.keys(values).length > 0) {
              return (
                <AutocompleteFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label="Usuario"
                  filterName="fullName"
                  options={dataBefore.data.usuarios}
                  // defaultOption={{ label: 'ECO', id: 1 }}
                  fullWidth={true}
                />
              )
            }
          },
        },
      },
    },
  ]

  return (
    <>
      {state.suspense && (
        <EditContextProvider>
          <Edit
            open={state.open}
            handleclose={setClose}
            data={state.data}
            setRender={setRender}
            render={render}
            setLoading={setLoading}
            dataBefore={dataBefore}
            loading={loading}
          />
        </EditContextProvider>
      )}

      <MuiDatables
        columns={columns}
        data={RowsTransit()}
        title={`Total de cajas: ${values.rows.length}`}
        apiCall={apiCall}
        count={values.header}
        render={render}
        setRender={setRender}
        onRowClick={(_, index) => cajaInfo(values.rows[index.dataIndex].id)}
        padding={windowSize ? '10px' : ''}
        searchEnabled={false}
      />
    </>
  )
}
export default CajaTable
